export var CrudRequestEventType = /*#__PURE__*/function (CrudRequestEventType) {
  CrudRequestEventType["RequestCompleted"] = "RequestCompleted";
  CrudRequestEventType["RequestFailed"] = "RequestFailed";
  return CrudRequestEventType;
}(CrudRequestEventType || {});